<template>
  <div class="main-chapter1">
    <div class="chapter-title">Форма 2. Первый лист журнала авторского надзора</div>
    <n-items>
      <n-input title="Генеральный подрядчик (подрядчик) " v-bind="$form.input('generalContractor')" :text="!editable" />
      <n-input title="Субподрядчики (исполнители отдельных видов работ):" v-bind="$form.input('subcontractors')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
    <n-loader :loading="$var('load')" />
  </div>
</template>

<script>
export default {
  name: 'MainChapter2',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  created() {
    this.$form.init({
      ...this.journal.data,
      subcontractors: [],
    })
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, 'author', this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
